export default "__VITE_ASSET__CHNmQAdH__"